import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Container } from '../components/ui';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';
import LeadForm from '../components/LeadForm';
import { SOLUTIONS, getCaseStudy } from '../data/content';

const SEGMENT_VALUE = {
  multifamily: 'multifamily',
  'commercial-industrial': 'commercial_industrial',
  'energy-brokers': 'energy_brokers',
};

export default function LandingPage() {
  const { slug } = useParams();
  const seg = SOLUTIONS[slug];
  if (!seg) return <Navigate to="/demo" replace />;
  const cs = getCaseStudy(seg.caseStudy);

  return (
    <section className="relative overflow-hidden bg-brand-ink">
      <div className="bp-grid-bg pointer-events-none absolute inset-0 opacity-40" />
      <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-brand/25 blur-[120px]" />
      <img src={seg.image} alt="" aria-hidden className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-10" />
      <Container className="relative grid grid-cols-1 items-center gap-12 py-16 sm:py-20 lg:grid-cols-2">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5 text-xs font-medium text-slate-200">
            <Icon name={seg.icon} className="h-3.5 w-3.5 text-brand" /> {seg.name}
          </span>
          <h1 className="mt-5 font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl md:text-[2.9rem]">{seg.headline}</h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">{seg.intro}</p>
          <ul className="mt-7 space-y-3">
            {seg.outcomes.slice(0, 4).map((o) => (
              <li key={o} className="flex items-start gap-3 text-sm text-slate-200">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand text-white"><Check className="h-3 w-3" /></span>{o}
              </li>
            ))}
          </ul>
          {cs && (
            <div className="mt-9 flex flex-wrap gap-x-8 gap-y-3 border-t border-white/10 pt-6">
              {cs.metrics.slice(0, 3).map((m) => (
                <div key={m.label}>
                  <div className="font-display text-2xl font-bold text-brand">{m.value}</div>
                  <div className="text-[11px] text-slate-400">{m.label}</div>
                </div>
              ))}
            </div>
          )}
        </Reveal>
        <Reveal delay={80}>
          <div className="rounded-2xl">
            <h2 className="mb-4 font-display text-xl font-bold text-white">Request your personalised demo</h2>
            <LeadForm source={`lp_${slug}`} defaultSegment={SEGMENT_VALUE[slug] || ''} />
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
